import { Box, styled } from "@acko-tech/building-blocks.ui.common";
import { Text } from "@acko-tech/building-blocks.ui.typography";
import { resolvePath } from "@utils/resolvePath";

export const Wrapper = styled.div`
  background-image: url(${resolvePath("/images/headerGradient.svg")});
  background-repeat: no-repeat;
  background-size: cover;
  position: absolute;
  top: 0;
  width: 100vw;
  height: 160px;
  left: 0;
  right: 0;
  pointer-events: none;
  z-index: 1005;
  ${(props: { isAddonGradient: any }) =>
    props.isAddonGradient
      ? `
      background-image: url(${resolvePath("/images/addon-header-gradient.svg")});
    `
      : `background-image: url(${resolvePath("/images/headerGradient.svg")});`}
`;

export const RegistraionNumberLottieWrapper = styled(Box)`
  position: relative;
  width: 256px;
  height: 256px;
  display: flex;
  flex-direction: column;
  padding-top: 103px;
  align-items: center;
  background: #fff;
  z-index: 2;
`;

export const RegNumberText = styled(Text)`
  position: absolute;
  left: 36%;
  bottom: 61.5%;
  color: #040222;
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  line-height: 16.024px;
  letter-spacing: 1.002px;

  @media (max-width: 768px) {
    left: 36%;
    bottom: 61.5%;
  }
`;

export const PrimaryText = styled(Text)`
  color: #5b5675;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  margin-top: 21px;
  @media (max-width: 768px) {
    font-size: 14px;
    line-height: 20px;
  }
`;

export const SecondaryText = styled(Text)`
  color: #451999;
  text-align: center;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  margin-top: 8px;
`;

export const ParentWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  height: 100vh;
  width: 100vw;
  position: fixed;
  top: ${(props) => (props.isDesktop ? "0" : "-5%")};
  left: 0;
  flex-direction: column;
  // background-color: ${(props) => (props.isDesktop ? "#040222cc" : "#fff")};
  background-color: #fff;
  //! WARNING DO NOT CHANGE Z-INDEX
  z-index: 1001;
  padding-bottom: ${(props) => (props.isDesktop ? "0" : "5vh")};
`;

export const  LottieWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #fff;
  z-index: 2;
  @media (max-width: 768px) {
    width: 90%;
    padding: 40px 20px;
  }
`;